<template>
  <TheHeader>
    <div class="contents-wrapper-01">
      <WholesaleEdit v-if="$store.state.wholesale.editingInfo.enabled" />
      <div class="bbs_title">
        도매
        <a-button size="large" type="link" shape="circle" icon="reload" @click="refreshWholesales" />
        <slot name="buttons" />
        <a-button
          style="margin: 5px;"
          class="fl-right"
          type="primary"
          shape="round"
          icon="plus-square"
          @click="onAdd"
        >도매 등록</a-button>
        <a-button
          style="margin: 5px;"
          shape="round"
          type="dashed"
          v-if="isPC"
          class="fl-right"
          @click="$router.go(-1)"
          icon="rollback"
        >뒤로가기</a-button>
      </div>
      <div class="acc-content-wrapper type2">
        <slot />
      </div>
      <WholesaleAdd v-if="addVisible" />
    </div>
  </TheHeader>
</template>
<script>
import WholesaleAdd from "./WholesaleAdd";
import WholesaleEdit from "./WholesaleEdit";
import { mapActions } from "vuex";
import TheHeader from "../TheLayout/TheHeader";

export default {
  name: "TheWholesale",
  components: { WholesaleAdd, WholesaleEdit, TheHeader },
  data() {
    return {
      addVisible: false
    };
  },
  methods: {
    ...mapActions(["refreshWholesales"]),
    onAdd() {
      /* 오류 임시 방편 */
      this.addVisible = false;
      setTimeout(() => (this.addVisible = true));
    }
  }
};
</script>
